import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { goodsService } from 'shared/src/api';

export const usePreloadGoodsRecommend = () => {
  const client = useQueryClient();

  const goodsSno = useGoodsSno();

  return useCallback(() => {
    client.prefetchQuery({
      queryKey: queryKey.goodsLikeRecommend(goodsSno, 'like'),
      queryFn: () => goodsService.getGoodsLikeRecommend(goodsSno),
    });
  }, [client, goodsSno]);
};
